import { render, staticRenderFns } from "./ExperimentTable.vue?vue&type=template&id=b2848828&"
import script from "./ExperimentTable.vue?vue&type=script&lang=js&"
export * from "./ExperimentTable.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports